export default __webpack_public_path__ + "static/media/facilitator.aa0f835b.png";